<template>
    <hsc-menu-style-custom class="text-left">
        <!-- menuZIndex élevé pour que le menu apparaisse au-dessus de tout composant -->
        <hsc-menu-button-menu :menuZIndex="1000" class="h-100" :ref="'menu' + ExportWorkId" disabled>
            <!-- Download -> "Télécharger" -->
            <!-- Rendu bouton -->
            <b-button v-if="RenderAsButton" v-b-tooltip.noninteractive.hover :title="$t('Download')" :disabled="checkDownloadDisabled()" variant="outline-dark" class="border-0 my-auto mr-1" :class="Size == 'sm' ? 'btn-circle-small' : 'btn-circle'">
                <b-icon icon="download" />
            </b-button>
            <!-- Rendu icone -->
            <b-icon v-else icon="download" v-b-tooltip.noninteractive.hover :title="$t('Download')" :disabled="checkDownloadDisabled()" :role="Disabled ? '' : 'button'" />

            <template slot="contextmenu">
				<!-- Composant générique d'export de composant Work -->
				<ExportWork :ExportWorkId="ExportWorkId"
                    :TargetWebAPI="'Analysis/' + Configs?.Feature" 
                    :Configs="Configs"
                    :ExtrasArgs="generateExtrasArgs()"
                    :ExportTypesEnabled="ExportTypesEnabled"
                    :Disabled="!DataSet || Object.keys(DataSet).length == 0"
                    v-on:CloseExportMenuEvent="$refs['menu' + ExportWorkId].$refs.menu.close(true)" />
            </template>
        </hsc-menu-button-menu>
    </hsc-menu-style-custom>
</template>
<script lang="ts">
	import { Prop, Vue } from "vue-property-decorator";
	import Component from 'vue-class-component';

	import Dictionary from "@/types/Dictionary";
    import HscMenuStyleCustom from "@/components/commons/HscMenuStyleCustom";

	/** Export de composants Work */
	import ExportWork from "./ExportWork.vue";
    import ExportTypeEnum from "@/enums/ExportTypeEnum";

    /** Composant d'export de composant Work spécifique à Analysis.vue */
	@Component({
		components: {
			ExportWork,
            'hsc-menu-style-custom': HscMenuStyleCustom("secondary")
		}
	})
	export default class AnalysisExportWork extends Vue {
        /** Données de résultat d'export du Work */
        @Prop()
        public DataSet!: any;

        /** Configuration du Work */
        @Prop()
        public Configs!: any;

        /** Id de l'élément html contenant le ChartWork pour exporter en Svg le Chart existant */
        @Prop()
        public ExportWorkId!: string;

        /** Taille du bouton d'export */
        @Prop({ default: () => "md" })
        public Size!: string;

        /** Indique si l'item de menu est activé ou désactivé */
		@Prop({ default: () => false })
		public Disabled!: boolean;

        /** Liste des exports activés */
        @Prop({ default: () => [] })
        public ExportTypesEnabled!: ExportTypeEnum[];

        /** Affiche l'icone en tant que bouton */
        @Prop({ default: () => true })
        public RenderAsButton!: boolean;

        /** Test si le bouton de téléchargement doit être désactivé ou non */
        private checkDownloadDisabled() {
            return this.Disabled || this.DataSet == undefined || !this.ExportTypesEnabled || (this.ExportTypesEnabled?.length == 0);
        }

		/** Génère les éléments props au téléchargement via Analysis */
		private generateExtrasArgs(): Dictionary<any> {
			return {
				DataSet: JSON.stringify(this.DataSet),
				Configs: this.Configs
			};
		}
	}
</script>
<style scoped>

</style>